module.exports = __webpack_public_path__ + "img/gastrohome-logo.1f64514d.png";